import axios from 'axios'
import type { SupportTicketStatus } from '../../shared/utils/types'
import { TONE } from '../../shared/theme/legacyTones'

/** Base REST do módulo de suporte (help desk). */
export const SUPPORT_BASE = '/api/suporte/tickets'

/** Rota da página de acompanhamento dos pedidos. */
export const SUPPORT_PAGE_PATH = '/support'

/** Mesmos tipos aceites pelo backend (BlobFileStorageService). */
export const SUPPORT_ACCEPTED_FILES = '.pdf,.png,.jpg,.jpeg,.webp,.gif,.doc,.docx,.xls,.xlsx,.ppt,.pptx'
export const SUPPORT_MAX_FILE_BYTES = 10 * 1024 * 1024
/** Cap do request multipart no backend (max-request-size=12MB), com folga para os campos de texto. */
export const SUPPORT_MAX_TOTAL_BYTES = 11 * 1024 * 1024

export const SUPPORT_TITULO_MAX = 150
export const SUPPORT_DESCRICAO_MAX = 4000

export const SUPPORT_STATUS_TONE: Record<SupportTicketStatus, { bg: string; color: string }> = {
  ABERTO: TONE.neutral,
  EM_ANALISE: TONE.info,
  RESOLVIDO: TONE.success,
  FECHADO: TONE.muted,
}

/** Mensagem de erro da API, com fallback traduzido. */
export function supportApiError(error: unknown, fallback: string): string {
  if (axios.isAxiosError<{ message?: string }>(error)) return error.response?.data?.message || fallback
  return fallback
}

export const formatSupportDate = (value: string) =>
  new Date(value).toLocaleDateString('pt-MZ', { day: '2-digit', month: 'short', year: 'numeric' })
